/**
 * Horizontal divider between groups of rows in a mobile shell drawer.
 */
export const DrawerDivider = () => (
  <div className="my-2 border-t border-primary" />
);
